var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 3C9.08331 3 8.33331 3.75 8.33331 4.66667C8.33331 5.58333 9.08331 6.33333 9.99998 6.33333C10.9166 6.33333 11.6666 5.58333 11.6666 4.66667C11.6666 3.75 10.9166 3 9.99998 3ZM9.99998 14.6667C9.08331 14.6667 8.33331 15.4167 8.33331 16.3333C8.33331 17.25 9.08331 18 9.99998 18C10.9166 18 11.6666 17.25 11.6666 16.3333C11.6666 15.4167 10.9166 14.6667 9.99998 14.6667ZM9.99998 8.83333C9.08331 8.83333 8.33331 9.58333 8.33331 10.5C8.33331 11.4167 9.08331 12.1667 9.99998 12.1667C10.9166 12.1667 11.6666 11.4167 11.6666 10.5C11.6666 9.58333 10.9166 8.83333 9.99998 8.83333Z",
    fill: "#2E353D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconItem);
export default __webpack_public_path__ + "static/media/icon_item.b3b573916d34677e9556d5d117a50cdc.svg";
export { ForwardRef as ReactComponent };